import {api} from '../../../shared';
import {
  CategoryGroupsFilter,
  CategoryGroupsWithMetaModel,
  CategoryGroupModel,
  CreateCategoryGroupDTO,
  EditCategoryGroupParams,
  CategoryGroupCategoriesFilter,
  CategoryGroupCategoriesWithMetaModel,
  CategoryGroupWithCategoriesModel,
} from '../model';

export const categoryGroupsApi = {
  getCategoryGroups: async (params: CategoryGroupsFilter = {}): Promise<CategoryGroupsWithMetaModel> => {
    const {data} = await api.get<CategoryGroupsWithMetaModel>('/api/fundraising/admin/category-groups', {params});
    return data;
  },

  getCategoryGroupById: async (categoryGroupId: string): Promise<CategoryGroupModel> => {
    const {data} = await api.get<CategoryGroupModel>(`/api/fundraising/admin/category-groups/${categoryGroupId}`);
    return data;
  },

  getCategoryGroupCategories: async (
    categoryGroupId: string,
    params: CategoryGroupCategoriesFilter = {},
  ): Promise<CategoryGroupCategoriesWithMetaModel> => {
    const {data} = await api.get<CategoryGroupCategoriesWithMetaModel>(
      `/api/fundraising/admin/category-groups/${categoryGroupId}/categories`,
      {params},
    );
    return data;
  },

  createCategoryGroup: async (categoryGroup: CreateCategoryGroupDTO): Promise<CategoryGroupModel> => {
    const {data} = await api.post<CategoryGroupModel>('/api/fundraising/admin/category-groups', categoryGroup);
    return data;
  },

  updateCategoryGroup: async ({categoryGroupId, ...payload}: EditCategoryGroupParams): Promise<CategoryGroupModel> => {
    const {data} = await api.post<CategoryGroupModel>(
      `/api/fundraising/admin/category-groups/${categoryGroupId}`,
      payload,
    );
    return data;
  },

  deleteCategoryGroup: async (categoryGroupId: string): Promise<void> => {
    await api.delete(`/api/fundraising/admin/category-groups/${categoryGroupId}`);
  },

  getCategoryGroupsWithCategories: async (): Promise<CategoryGroupWithCategoriesModel[]> => {
    const {data} = await api.get<CategoryGroupWithCategoriesModel[]>(
      '/api/fundraising/admin/category-groups-with-categories',
    );
    return data;
  },
};
